import React, { useState } from 'react';
import {
  CircularProgress,
  IconButton,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { useConfirm } from 'material-ui-confirm';
import moment from 'moment-timezone';
import { Edit as EditIcon, Delete as DeleteIcon } from '@material-ui/icons';

import { validatePassword } from '../../lib/validate/validate';

import {
  createAdministrator,
  listAdministrator,
  deleteAdministrator,
  updateAdministrator,
} from '../../services/AdministratorService';

import SelectAdministratorEmail from '../../components/AutoComplete/AutoCompleteAdministratorEmail';
import SelectAdministratorName from '../../components/AutoComplete/AutoCompleteAdministratorName';
import SelectSystemCode from '../../components/Dropdown/SelectSystemCode';
import Table, {
  columnType,
  tempFilteredRows,
} from '../../components/ClearingTable/Table';
import SelectRole from '../../components/Dropdown/SelectRole';
import QueryParam from '../../services/QueryParamService';
import Button from '../../components/Buttons/Button';
import Text from '../../components/Typography/Text';
import {
  notifySuccess,
  notifyInfo,
  notifyError,
} from '../../components/Messages/Notification';

import AdministratorModal from './Components/AdministratorModal';
import { getCurrentUser } from '../../services/AuthService';

export default function Administrator() {
  const confirm = useConfirm();
  const { IsAdmin, Correspondent } = getCurrentUser();

  const isDeleteEnabled = (data) => {
    return data?.status !== 'Inactive';
  };
  const [lockTable, setLockTable] = useState(true);
  const [searchDataCsv, setSearchDataCsv] = React.useState([]);
  const [pagination, setPagination] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [previousRows, setPreviousRows] = useState(0);
  const [rowData, setRowData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState({
    search: false,
    save: false,
    delete: false,
  });
  const [rows, setRows] = useState([]);
  const [modalAddAction, setModalAddAction] = React.useState(false);
  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      name: '',
      email: '',
      userType: '',
      roleId: 0,
      roleName: '',
      status: 'Active',
      isPendingClients: false,
    })
  );

  const columns = [
    {
      name: 'actions',
      label: 'Actions',
      type: columnType.buttons,
      options: {
        customBodyRenderLite: (dataIndex) => {
          if (!IsAdmin) {
            return <div style={{ margin: 0, padding: 0 }}></div>;
          }
          return (
            <div align="left" className="grd-row" style={{ margin: 0 }}>
              <div className="grd-cell-none">
                <IconButton
                  aria-label="delete"
                  disabled={
                    !isDeleteEnabled(tempFilteredRows[dataIndex]) || loading.delete
                  }
                  onClick={() => handleDelete(tempFilteredRows[dataIndex])}
                >
                  {loading.delete && dataIndex ? (
                    <CircularProgress
                      style={{ color: '#1e7dff', height: 20, width: 20 }}
                    />
                  ) : (
                    <DeleteIcon style={{ height: 20, width: 20 }} />
                  )}
                </IconButton>
                <IconButton
                  aria-label="edit"
                  disabled={loading.delete}
                  onClick={() => handleOpen(tempFilteredRows[dataIndex])}
                >
                  <EditIcon style={{ height: 20, width: 20 }} />
                </IconButton>
              </div>
            </div>
          );
        },
        sort: false,
      },
    },
    {
      name: 'name',
      label: 'User',
    },
    {
      name: 'roleName',
      label: 'Role Name',
    },
    {
      name: 'email',
      label: 'Email',
      width: '300px',
    },
    {
      name: 'mobileNo',
      label: 'Mobile No',
    },
    {
      name: 'userType',
      label: 'User Type',
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
      options: {
        display: false,
      },
    },
    {
      name: 'admin',
      label: 'Admin',
      type: columnType.bool,
    },
    {
      name: 'accountId',
      label: 'Account ID',
      options: {
        display: false,
      },
    },
    {
      name: 'accountNo',
      label: 'Account No',
    },
    {
      name: 'status',
      label: 'Status',
    },
    {
      name: 'authenticationMode',
      label: 'Authentication Mode',
    },
    {
      name: 'onboardingPercent',
      label: 'Onboarding Percent',
      type: columnType.percentage,
    },
    {
      name: 'createdAt',
      label: 'Created At',
      options: {
        display: false,
      },
    },
    {
      name: 'createdBy',
      label: 'Created By',
    },
    {
      name: 'modifiedAt',
      label: 'Modified At',
      options: {
        display: false,
      },
    },
    {
      name: 'modifiedBy',
      label: 'Modified By',
    },
    {
      name: 'lastLogin',
      label: 'Last Login',
      options: {
        display: false,
      },
    },
  ];

  const options = {
    serverSide: true,
    responsive: 'standard',
    selectableRows: 'none',
  };

  const handleChange = (e, checkboxValue) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    if (['roleName'].includes(input.name)) {
      searchData.roleId = input.roleId;
      searchData.roleName = input.value;
    }

    setSearchData({
      ...searchData,
      [input.name]:
        checkboxValue === true || checkboxValue === false ? checkboxValue : input.value,
    });
  };

  const getCsvData = async () => {
    if (lockTable === true) {
      return [];
    }
    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: totalRows,
    };

    const data = await listAdministrator(searchDataCsv, paginationCopy);
    const rows = data.administratorsList.map((data) => ({
      userId: data.usrId,
      user: data.name,
      roleName: data.roleName,
      email: data.email,
      mobileNo: data.mobileNo,
      userType: data.userType,
      status: data.status,
      authenticationMode: data.authenticationMode,
      onboardingPercent: data.onboardingPercent,
      createdAt: data.createdAt
        ? moment(new Date(data.createdAt.seconds * 1000)).format('MM/DD/YYYY hh:mm')
        : '--',
      modifiedAt: data.modifiedAt
        ? moment(new Date(data.modifiedAt.seconds * 1000)).format('MM/DD/YYYY hh:mm')
        : '--',
      modifiedBy: data.modifiedBy,
      createdBy: data.createdBy,
      lastLogin: data.lastLogin
        ? moment(new Date(data.lastLogin.seconds * 1000)).format('MM/DD/YYYY hh:mm')
        : '--',
      accountNo: data.accountNo,
    }));
    return rows;
  };

  const handleSearch = async (paginationChange) => {
    try {
      if (paginationChange !== true) {
        setLoading({ ...loading, search: true });
        setLockTable(false);
      }
      if (paginationChange === true) {
        if (lockTable === true) {
          return;
        }
      }
      QueryParam.set(searchData);
      let paginationCopy = {
        ...pagination,
        reload: false,
        pageNo: paginationChange === true ? pagination.pageNo : 0,
        rowsPerPage: pagination.rowsPerPage || 100,
      };
      if (previousRows !== 0) {
        if (previousRows < pagination.rowsPerPage * pagination.pageNo) {
          paginationCopy.pageNo = 0;
        }
      }
      if (paginationChange !== true) {
        paginationCopy.filterNames = [];
        paginationCopy.filterValues = [];
      }
      const data = await listAdministrator(searchData, paginationCopy);
      const rows = data.administratorsList.map((data) => ({
        usrId: data.usrId,
        roleName: data.roleName,
        roleId: data.roleId,
        name: data.name,
        email: data.email,
        onboardingPercent: data.onboardingPercent,
        createdAt: data.createdAt
          ? moment(new Date(data.createdAt.seconds * 1000)).format('MM/DD/YYYY hh:mm')
          : '--',
        modifiedAt: data.modifiedAt
          ? moment(new Date(data.modifiedAt.seconds * 1000)).format('MM/DD/YYYY hh:mm')
          : '--',
        lastLogin: data.lastLogin
          ? moment(new Date(data.lastLogin.seconds * 1000)).format('MM/DD/YYYY hh:mm')
          : '--',
        // password: data.password,
        // passwordConfirm: data.password,
        defaultAccess: data.defaultAccess,
        mobileNo: data.mobileNo,
        userType: data.userType,
        status: data.status,
        admin: data.admin,
        correspondent: data.correspondent,
        accountNo: data.accountNo,
        authenticationMode: data.authenticationMode,
        secretKey: data.secretKey,
        authenticationText: data.authenticationMode.includes('Text'),
        authenticationEmail: data.authenticationMode.includes('Email'),
        authenticationAuthenticator: data.authenticationMode.includes('Authenticator'),
        modifiedBy: data.modifiedBy,
        createdBy: data.createdBy,
        accountId: data.accountId,
      }));
      setSearchDataCsv(searchData);
      setTotalRows(data.summary.totalRows);
      setPreviousRows(totalRows);
      paginationCopy.count = data.summary.totalRows;
      setPagination(paginationCopy);
      setRows(rows);
      if (paginationChange !== true) {
        notifyInfo(data.summary.totalRows + ' search results.');
      }
    } catch (error) {
      console.error(error);
      notifyError(error.message);
    } finally {
      setLoading({ ...loading, search: false });
    }
  };

  const handleOpen = (data, isAdd) => {
    if (isAdd) {
      data = {
        usrId: 0,
        name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        defaultAccess: '',
        userType: 'Client',
        status: 'Active',
        admin: false,
        correspondent: Correspondent,
        authenticationMode: 'Email',
        authenticationText: false,
        authenticationEmail: false,
      };
      setModalAddAction(true);
    } else {
      data.correspondent = data.correspondent.trim();
      setModalAddAction(false);
    }
    setRowData(data);
    setOpen(true);
  };

  const handleClose = async (data, isAdd) => {
    if (!data) {
      setOpen(false);
      return;
    }
    let valid = true;
    try {
      if (!data.name) {
        notifyError('Name is required.');
        valid = false;
      }

      if (!data.email) {
        notifyError('Email is required.');
        valid = false;
      }

      if (!data.roleId) {
        notifyError('Role Name is required.');
        valid = false;
      }

      if (!data.mobileNo) {
        notifyError('Mobile No is required.');
        valid = false;
      }

      if (!data.userType) {
        notifyError('User type is required.');
        valid = false;
      }

      if (!data.status) {
        notifyError('Status is required.');
        valid = false;
      }

      if (!data.accountNo) {
        notifyError('Account No is required.');
        valid = false;
      }

      if (isAdd) {
        if (!data.password) {
          notifyError('Password is required.');
          valid = false;
        }

        if (data.password !== data.passwordConfirm) {
          notifyError('Password does not match.');
          valid = false;
        }

        if (validatePassword(data.password).err) {
          notifyError('Password does not meet the requirement.');
          valid = false;
        }

        if (validatePassword(data.passwordConfirm).err) {
          notifyError(' does not meet the requirement.');
          valid = false;
        }
      } else {
        if (data.password) {
          if (data.password !== data.passwordConfirm) {
            notifyError('Password does not match.');
            valid = false;
          }

          if (validatePassword(data.password).err) {
            notifyError('Password does not meet the requirement.');
            valid = false;
          }

          if (validatePassword(data.passwordConfirm).err) {
            notifyError('Confirm Password does not meet the requirement.');
            valid = false;
          }
        }
      }

      if (!data.authenticationEmail && !data.authenticationText) {
        notifyError('At least 1 authentication mode is required.');
        valid = false;
      } else {
        var mode = '';
        mode = data.authenticationEmail ? 'Email,' : '';
        mode = mode + (data.authenticationText ? 'Text,' : '');
        data.authenticationMode = mode;
      }

      if (data.userType !== 'Client') {
        data.admin = false;
      }

      if (!valid) {
        return;
      }

      setLoading({ ...loading, save: true });

      if (isAdd) {
        //ADD
        const resp = await createAdministrator(data);
        const response = resp.administrator;
        response.createdAt = response.createdAt
          ? moment(new Date(response.createdAt.seconds * 1000)).format('MM/DD/YYYY hh:mm')
          : '--';
        response.modifiedAt = response.modifiedAt
          ? moment(new Date(response.modifiedAt.seconds * 1000)).format(
              'MM/DD/YYYY hh:mm'
            )
          : '--';
        response.lastLogin = response.lastLogin
          ? moment(new Date(response.lastLogin.seconds * 1000)).format('MM/DD/YYYY hh:mm')
          : '--';
        response.password = '';
        setRows([response, ...rows]);
        notifySuccess('New Administrator has been added.');
      } else {
        await updateAdministrator(data);
        // need to call handleSearch to check if user auth is still valid
        handleSearch(true);

        notifySuccess('An Administrator has been updated.');
      }
      setOpen(false);
    } catch (error) {
      console.error(error);
      setLoading({ ...loading, save: false });
      notifyError(error.message);
    }

    setLoading({ ...loading, save: false });
  };

  const handleDelete = async (data) => {
    try {
      await confirm({
        description:
          "You are about to set the user '" +
          data.name +
          "' as 'Inactive'. Please confirm your action.",
        confirmationText: 'Yes, delete',
      });
    } catch (error) {
      return;
    }

    setLoading({ ...loading, delete: true });
    try {
      await deleteAdministrator(data.usrId);
      notifySuccess('User has been set to Inactive');
      handleSearch(true);
    } catch (error) {
      notifyError(error.message);
    }
    setLoading({ ...loading, delete: false });
  };

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="User" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading.search}
              loading={loading.search}
              type="search"
              label={loading.search ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
          {IsAdmin && (
            <div className="grd-cell-none">
              <Button
                disabled={loading.add}
                loading={loading.add}
                type="plus"
                label="Add New"
                onClick={() => {
                  handleOpen('', true);
                }}
              />
            </div>
          )}
        </div>
        <div className="grd-row">
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectAdministratorName
              name="name"
              label="User"
              freeSolo={true}
              value={searchData.name}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectAdministratorEmail
              name="email"
              label="Email"
              freeSolo={true}
              value={searchData.email}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectSystemCode
              name="userType"
              label="User Type"
              type="User Type"
              value={searchData.userType}
              onChange={handleChange}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <SelectRole
              name="roleName"
              label="Role Name"
              value={searchData.roleName}
              onChange={handleChange}
            />
          </div>
          <div className="grd-cell">
            <SelectSystemCode
              name="status"
              label="Status"
              type="Status"
              subType="AI"
              value={searchData.status}
              onChange={handleChange}
            />
          </div>
          <div className="grd-cell" style={{ marginRight: 30 }}>
            <InputLabel shrink>Pending Clients</InputLabel>
            <FormControlLabel
              control={
                <Checkbox
                  name="isPendingClients"
                  checked={searchData.isPendingClients}
                  onChange={handleChange}
                />
              }
              label=""
            />
          </div>
        </div>
      </div>
      <div className="mt-20">
        <Table
          title={'User'}
          data={rows}
          columns={columns}
          options={options}
          pagination={pagination}
          setPagination={setPagination}
          onSearch={handleSearch}
          getCsvData={getCsvData}
        />
      </div>
      {open && (
        <AdministratorModal
          onClose={handleClose}
          open={open}
          add={modalAddAction}
          value={rowData}
          loading={loading.save}
        />
      )}
    </form>
  );
}
